module.exports = __webpack_public_path__ + "img/beatles.9d7a2151.jpg";